<script>
  import { onMount } from "svelte";
  import Meta from "./Meta.svelte";
  import Header from "./pudding/Header.svelte";
  import Icon from "./helpers/Icon.svelte";

  let count;

  const fetchViewCount = async (url) => {
    const response = await fetch(url);
    const { updated, views } = await response.json();
    console.log({ updated });
    return views;
  };

  const gotEm = (e) => {
    e.target.innerText = `${e.target.innerText} 😉`;
    window.location.href = "https://www.youtube.com/watch?v=dQw4w9WgXcQ";
  };

  onMount(async () => {
    const v = Date.now();
    const url = `https://pudding.cool/2021/07/rickrolling-data/data.json?version=${v}`;
    count = await fetchViewCount(url);
  });
</script>

<Meta />

<Header />

<section>
  <div class="strip">
    <video src="assets/b.mp4" preload loop autoplay muted></video>
    <video src="assets/a.mp4" preload loop autoplay muted></video>
    <video src="assets/c.mp4" preload loop autoplay muted></video>
  </div>
  <h1 class="hed">A Visual History of <span>Rickrolling</span></h1>
  <p class="dek">
    <a
      target="_blank"
      rel="noopener"
      href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
      >Never Gonna Give You Up <span><Icon name="external-link" /></span></a
    >
    has <span>{count || "nearly a billion"} views</span> on YouTube. To
    commemorate it hitting one billion views, we analyzed millions of comments,
    posts, and links to chart the definitive history of the
    <a
      target="_blank"
      rel="noopener"
      href="https://en.wikipedia.org/wiki/Rickrolling"
      >Rickroll <span><Icon name="external-link" /></span></a
    >.
  </p>

  <p class="byline">
    By <a href="https://pudding.cool/author/russell-samora">Russell Samora</a>
    <time>July 2021</time>
  </p>

  <button on:click="{gotEm}">Start</button>
  <p class="warning">
    This experience has audio <span><Icon name="volume-2" /></span>
  </p>
</section>

<style>
  .byline {
    margin: 0;
    line-height: 1;
    position: absolute;
    left: 0;
    bottom: 1em;
    width: 100%;
    text-align: center;
    display: none;
  }

  .strip {
    margin: 2em auto;
    display: flex;
    justify-content: center;
  }

  .strip video {
    width: 25%;
    max-width: 160px;
    max-height: 160px;
    margin: 0 0.5em;
    border-radius: 50%;
    border: 2px solid var(--black);
  }

  .hed {
    margin-top: 1em;
    line-height: 1.2;
    font-size: 24px;
    text-align: center;
  }

  .hed span {
    display: block;
    font-size: 48px;
    text-transform: uppercase;
    font-weight: bold;
  }

  .dek {
    font-size: 17px;
    margin: 0 auto;
    max-width: 31em;
    padding: 0 1em;
  }

  .dek span {
    font-weight: bold;
  }

  .warning {
    line-height: 1;
    display: flex;
    font-size: 18px;
    color: var(--gray-dark);
    justify-content: center;
  }

  .warning span {
    margin-left: 0.5em;
  }

  button {
    display: block;
    margin: 0 auto;
    margin-top: 1em;
    font-size: 24px;
    color: var(--white);
    background-color: var(--off-black);
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: 0.05em;
    padding: 0.75em;
    width: 7em;
    transition: all 250ms;
    box-shadow: 0 0 0 0 var(--yellow);
  }

  button:hover {
    box-shadow: 0 0 4px 4px var(--purple);
  }

  a span {
    font-size: 0.75em;
  }

  @media only screen and (min-height: 650px) {
    .byline {
      display: block;
    }
  }

  @media only screen and (min-width: 800px) {
    .hed {
      font-size: 24px;
      line-height: 1;
    }

    .hed span {
      font-size: 64px;
    }

    .dek {
      font-size: 18px;
    }

    .byline {
      display: block;
      top: 2em;
      left: 2em;
      width: auto;
      bottom: auto;
      text-align: left;
    }

    .strip video {
      max-width: 165px;
      max-height: 165px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .hed {
      font-size: 36px;
      line-height: 1;
    }

    .hed span {
      font-size: 96px;
    }

    .dek {
      font-size: 21px;
    }

    .strip video {
      max-width: 200px;
      max-height: 200px;
    }

    button {
      margin-top: 2em;
    }
  }
</style>
